import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../../CSS/private/PageContent_SideBar.css';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';

/**
 * @param {*} props - header          = an array of column headers
 *                  - rowCount        = number of rows. If none, 1 row is used
 *                  - options         = an array of optional values in form [<option>,<option>,...]
 *                  - values          = a 2-D array of initial values in form [[values], [values], [values]]
 *                  - setValue        = a function to call. Must take parameters: key, row, column, value
 *                  - editFunction    = the function to call when editing information
 *                  - deleteFunction  = the function to call when deleting information
 *                  - numbered        = flag to show the entries with a number
 *                  - tableKey        = a key for when using multiple tables
 */
function SubTabSelectTable(props) {

  const smallColumnWidth = '25px';

  const narrow = props.narrow;
  var header = props.header;
  const rowCount = (props.rowCount === undefined? 1 : props.rowCount);
  const options = props.options;
  const values = props.values;
  const setValue = props.setValue;
  const editFunction = props.editFunction;
  const deleteFunction = props.deleteFunction;
  const numbered = props.numbered;
  const initialHeaderLength = header.length;
  const tableKey = props.tableKey;
  const editingEnabled = props.editingEnabled;
  
  var smallColumns = 0;
  if(numbered) smallColumns++
  if(editFunction !== undefined) smallColumns++;
  if(deleteFunction !== undefined) smallColumns++;
  
  const columnWidth = 'calc(' + (100 / initialHeaderLength) + '% - ' + (smallColumns * 25 / initialHeaderLength) + 'px)';
  

  var headerColumns = header.map((column, i) => {
    return (<Column key={i} width={columnWidth} data={column} />)
  })

  // Add additional header columns depending on settings
  if(numbered) {
    headerColumns = [(<Column key='edit' smallColumn width={smallColumnWidth}/>), ...headerColumns]
  }

  if(props.editFunction !== undefined) {
    headerColumns = [...headerColumns, (<Column key='edit' smallColumn width={smallColumnWidth}/>)]
  }

  if(props.deleteFunction !== undefined) {
    headerColumns = [...headerColumns, (<Column key='delete' smallColumn width={smallColumnWidth}/>)]
  }

  var tableContent = [];
  for(let r = 0; r < rowCount; r++)
  {
    var rowContent = []
    for(let c = 0; c < initialHeaderLength; c++)
    {
      rowContent=[...rowContent, (<SelectColumn key={[r,c]} r={r} c={c} tableKey={tableKey} addNull={props.addNull} width={columnWidth} options={options} value={values[r][c]} setValue={setValue} editingEnabled={editingEnabled} />)]
    }

    if(numbered) {
      rowContent = [(<Column key='number' smallColumn number width={smallColumnWidth} data={r+1} />), ...rowContent]
    }
    if(props.editFunction !== undefined) {
      rowContent = [...rowContent, (<Column key='edit' smallColumn width={smallColumnWidth} data={<FontAwesomeIcon icon={faEdit} />} />)]
    }
    if(props.deleteFunction !== undefined) {
      rowContent = [...rowContent, (<Column key='delete' smallColumn width={smallColumnWidth} data={<FontAwesomeIcon icon={faTrash} />} />)]
    }

    tableContent = [...tableContent, rowContent];
  }


  const sectionTitle = (props.title !== undefined)? (
    <div className='slp-subtab-section-title'>
      {props.title}
    </div>
   ) : null

   const sectionDescription = (props.description !== undefined)? (
    <div className='slp-subtab-section-description'>
      {props.description}
    </div>
   ) : null

   const sectionDetails = (props.title !== undefined || props.description !== undefined)? (
    <div className={'slp-subtab-details' + (props.narrow? '-narrow' : '')}>
      {sectionTitle}
      {sectionDescription}
    </div>
   ) : null;


  return (

    <div className='slp-subtab-section-container'>
      {sectionDetails}
      <div className={'slp-subtab-table' + (narrow? '-narrow' : '')}>

        <div className='slp-subtab-table-header-row'>
          {headerColumns}
        </div>
        {tableContent}

      </div>
    </div>

  )

}

export default SubTabSelectTable;



function SelectColumn(props) {

  const tableKey = props.tableKey;
  const r = props.r;
  const c = props.c;
  const options = props.options;
  const value = props.value;
  const setValue = props.setValue;
  const editingEnabled = props.editingEnabled;

  return (
    <select className={'slp-subtab-select-table-column'}
        defaultValue={value}
        onChange={(e) => setValue(tableKey, r, c, e.target.value)}
        style={{
          ...{width: props.width}
        }}
        disabled={!editingEnabled}
    >
      {props.addNull? (
          <option value={null}></option>
      ) : null}
      {options}
    </select>)
}

function Column(props) {
  return (
    <div className={'slp-subtab-table-column' + (props.smallColumn? '-small' : '')}
         style={{
          ...{width: props.width},
          ...(props.data === null)? {color: '#555555'} : null,
          ...(props.number)? {color: '#777777'} : null,
          ...(props.number)? {fontSize: '12px'} : null,
          ...(props.number)? {fontWeight: '600'} : null,
        }}
    >
      {props.data !== null? props.data : 'n/a'}
    </div>)
}